/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Silent_Silver_Elephant_ZoomInputs */

const en_silent_silver_elephant_zoom = /** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Note: If you've already done a free trial of ${i?.displayName}, you won't be able to redeem another trial.`)
};

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const id_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const ms_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const ca_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const cs_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const da_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const de_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const et_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const es_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const fr_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const hr_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const it_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const lv_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const lt_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const hu_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const nl_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const nb_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const pl_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const pt_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const ro_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const sk_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const sl_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const fi_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const sv_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const vi_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const tr_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const el_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const bg_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const ru_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const sr_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const uk_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const ka_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const hi_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const th_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const ko_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const zh_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const zh_tw_silent_silver_elephant_zoom = zh_silent_silver_elephant_zoom;

/** @type {(inputs: Silent_Silver_Elephant_ZoomInputs) => LocalizedString} */
const ja_silent_silver_elephant_zoom = en_silent_silver_elephant_zoom;

/**
* | output |
* | --- |
* | "Note: If you've already done a free trial of {displayName}, you won't be able to redeem another trial." |
*
* @param {Silent_Silver_Elephant_ZoomInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const silent_silver_elephant_zoom = /** @type {((inputs: Silent_Silver_Elephant_ZoomInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Silent_Silver_Elephant_ZoomInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_silent_silver_elephant_zoom(inputs)
	if (locale === "ms") return ms_silent_silver_elephant_zoom(inputs)
	if (locale === "ca") return ca_silent_silver_elephant_zoom(inputs)
	if (locale === "cs") return cs_silent_silver_elephant_zoom(inputs)
	if (locale === "da") return da_silent_silver_elephant_zoom(inputs)
	if (locale === "de") return de_silent_silver_elephant_zoom(inputs)
	if (locale === "et") return et_silent_silver_elephant_zoom(inputs)
	if (locale === "es") return es_silent_silver_elephant_zoom(inputs)
	if (locale === "fr") return fr_silent_silver_elephant_zoom(inputs)
	if (locale === "hr") return hr_silent_silver_elephant_zoom(inputs)
	if (locale === "it") return it_silent_silver_elephant_zoom(inputs)
	if (locale === "lv") return lv_silent_silver_elephant_zoom(inputs)
	if (locale === "lt") return lt_silent_silver_elephant_zoom(inputs)
	if (locale === "hu") return hu_silent_silver_elephant_zoom(inputs)
	if (locale === "nl") return nl_silent_silver_elephant_zoom(inputs)
	if (locale === "nb") return nb_silent_silver_elephant_zoom(inputs)
	if (locale === "pl") return pl_silent_silver_elephant_zoom(inputs)
	if (locale === "pt") return pt_silent_silver_elephant_zoom(inputs)
	if (locale === "ro") return ro_silent_silver_elephant_zoom(inputs)
	if (locale === "sk") return sk_silent_silver_elephant_zoom(inputs)
	if (locale === "sl") return sl_silent_silver_elephant_zoom(inputs)
	if (locale === "fi") return fi_silent_silver_elephant_zoom(inputs)
	if (locale === "sv") return sv_silent_silver_elephant_zoom(inputs)
	if (locale === "vi") return vi_silent_silver_elephant_zoom(inputs)
	if (locale === "tr") return tr_silent_silver_elephant_zoom(inputs)
	if (locale === "el") return el_silent_silver_elephant_zoom(inputs)
	if (locale === "bg") return bg_silent_silver_elephant_zoom(inputs)
	if (locale === "ru") return ru_silent_silver_elephant_zoom(inputs)
	if (locale === "sr") return sr_silent_silver_elephant_zoom(inputs)
	if (locale === "uk") return uk_silent_silver_elephant_zoom(inputs)
	if (locale === "ka") return ka_silent_silver_elephant_zoom(inputs)
	if (locale === "hi") return hi_silent_silver_elephant_zoom(inputs)
	if (locale === "th") return th_silent_silver_elephant_zoom(inputs)
	if (locale === "ko") return ko_silent_silver_elephant_zoom(inputs)
	if (locale === "zh") return zh_silent_silver_elephant_zoom(inputs)
	if (locale === "zh-tw") return zh_tw_silent_silver_elephant_zoom(inputs)
	if (locale === "ja") return ja_silent_silver_elephant_zoom(inputs)
	return en_silent_silver_elephant_zoom(inputs)
});